import * as helper from './helper.js';

export const state = {
	gridData: {},
	sheetData: {
		id: '',
		imgfilename: '',
		pdffilename: '',
		title: '',
		desc: '',
		relatedItemsIds: [],
	},
	relatedItems: {
		page: 1,
		itemsPerPage: 3,
		items: [],
	},
};
export const loadGridData = async function (jsonID) {
	try {
		state.gridData = await helper.getJsonData(`../json/${jsonID}.json`);
	} catch (err) {
		console.log(err);
		throw err;
	}
};
export const loadSheetData = async function (sheetId) {
	try {
		//1. retrieve sheet data
		state.sheetData = await retrieveSheetData(sheetId);

		//2.load related items data if exist
		// if (state.sheetData.relatedItemsIds)
		// 	await loadRelatedItemsData(state.sheetData.relatedItemsIds);
	} catch (err) {
		console.error(`Error:${err}`);
		throw err;
	}
};

//Accepts an array of relatedItems ids, returns an array of relatedItems sheets
export const loadRelatedItemsData = async function (relatedItemsIds) {
	try {
		const items = [];
		for (let i = 0; i < relatedItemsIds.length; i++) {
			const item = await retrieveSheetData(relatedItemsIds[i]);
			items.push(item);
		}

		state.relatedItems.items = items;
	} catch (err) {
		throw err;
	}
};

export const getRelatedItemsPage = function (page) {
	state.relatedItems.page = page;

	const start = (page - 1) * state.relatedItems.itemsPerPage;
	const end = page * state.relatedItems.itemsPerPage;

	console.log(`start: ${start}, end:${end}`);
	return {
		items: state.relatedItems.items.slice(start, end),
		page: state.relatedItems.page,
		itemsPerPage: state.relatedItems.itemsPerPage,
	};
};
const retrieveSheetData = async function (sheetId) {
	try {
		//1. get parent jsonId file of the sheet
		const jsonId = helper.getJsonId(sheetId.slice(0, sheetId.indexOf('-')));

		//2. Fetch file data
		const gridData = await helper.getJsonData(`../json/${jsonId}.json`);

		//3. Find erequird sheet
		const sheetData = gridData.data.filter(
			(element) => element.id === sheetId
		)[0];

		if (!sheetData) {
			throw new Error('Required file does not exist');
		}
		//4. return sheetData
		return sheetData;
	} catch (err) {
		console.error(`Error:${err}`);
		throw err;
	}
};

// export const loadGridData = async function (jsonID) {
// 	try {
// 		const res = await fetch(`../json/${jsonID}.json`);
// 		const data = await res.json();
// 		if (!res.ok) throw new Error(`${data.message} (${res.status})`);
// 		state.gridData = data;
// 	} catch (err) {
// 		throw err;
// 	}
// };
